import { render, staticRenderFns } from "./view_Faq.vue?vue&type=template&id=b4f3838e&"
import script from "./view_Faq.vue?vue&type=script&lang=js&"
export * from "./view_Faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports